module.exports = __webpack_public_path__ + "img/rluijten-tablet_79b3ca5e867f2465944fb1eac0115ccc.jpg";


//////////////////
// WEBPACK FOOTER
// ./client/img/rluijten-tablet.jpg
// module id = 248
// module chunks = 0